import {
    PROJECTS_USERS_LOADED,
    PROJECTS_ROLES_LOADED,
    PROJECTS_USERS_ROLES_LOADING
} from '../store/actionTypes';
import * as _ from 'lodash';
import {ProjectOption, ProjectsAction, ProjectsState} from 'types/projects';


export const DEFAULT_STATE: ProjectsState = {
    users: null,
    roles: null
};

export default function projectsReducer(state: ProjectsState = DEFAULT_STATE, action: ProjectsAction): ProjectsState {
    // every case builds the fields it changes, which is what is then laid over the state
    let partialState: Partial<ProjectsState>;
    switch (action.type) {

        case PROJECTS_USERS_ROLES_LOADING:
            partialState = {
                loading: true
            };

            return Object.assign({}, state, partialState);

        case PROJECTS_USERS_LOADED:
            partialState = Object.assign({}, state);

            // a name once looked up is kept, so a second line holding the same approver adds
            // nothing
            partialState.users = (partialState.users || [])
                .concat(action.data || [])
                .filter((user, index, arr) =>
                    arr.findIndex((u) => (u.value === user.value)) === index
                );


            return Object.assign({}, state, partialState);


        case PROJECTS_ROLES_LOADED:
            partialState = Object.assign({}, state);
            let currentRoles = action.data;
            partialState.roles = _.unionWith(currentRoles, _.isEqual);

            return Object.assign({}, state, partialState);


        default:
            return state;
    }
}


export function getProjectsUsers(state: ProjectsState): ProjectOption[] | null {
    return state.users;
}

export function getProjectsRoles(state: ProjectsState): ProjectOption[] | null {
    return state.roles;
}
